import { useEffect, useState } from "react";
import useAuthStore from "../../store/useAuthStore";
import { useProfileUpdateStore } from "../../store/useProfileUpdateStore";
import { useUserStore } from "../../store/useUserStore";
import { useRegisterQuestionsStore } from "../../store/useRegisterQuestionsStore";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

type PersonalityProps = {
  onSaveSuccess: () => void;              // ✅ callback to scroll
  
};

const Personality: React.FC<PersonalityProps> = ({ onSaveSuccess }) => {
  const { activeSection, setActiveSection, updateProfile } = useProfileUpdateStore();
  const { getRegisterQuestions, getQuestionByTitle } = useRegisterQuestionsStore();
  const authStore = useAuthStore.getState();
  const userId = authStore.user.id;
  const user = useUserStore((state) => state.user);
  const getUserDetails = useUserStore((state) => state.getUserDetails);

  // Local state for controlled inputs

  const [selectedAnswers, setSelectedAnswers] = useState<Record<number, number[]>>({});

  const [errors, setErrors] = useState<{
      personality?: string,
      
     
    }>({});

  useEffect(() => {
    getRegisterQuestions();
  }, [user]);

  // Initialize selectedAnswers from user.user_answers
useEffect(() => {
    if (user?.user_answers?.length > 0) {
      const initialAnswers: { [key: string]: number[] } = {};
      user.user_answers.forEach((answer: any) => {
        initialAnswers[answer.question_id] = answer.answer_id;
      });
      console.log('initialAnswers',initialAnswers);
      
      setSelectedAnswers(initialAnswers);
    }
  }, [user.user_answers]); // Run when user answers are fetched

  useEffect(() => {
    if (!user || user.id !== userId) {
      getUserDetails(userId);
    }
  }, [userId, user, getUserDetails]);

  if (activeSection !== "personality") return null;

  // Function to validate form before submission
  const validateForm = () => {
    const newErrors: {
        personality?: string; 
       
         
} = {
   
};

   

    const personalityQuestion = getQuestionByTitle("Personality");
    if (personalityQuestion && !selectedAnswers[personalityQuestion.id]) {
      newErrors.personality = "Personality is required.";
    }



   

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const selectOption = (questionId: number, answerId: number) => {
    console.log('answerId', answerId);
    console.log('selectedAnswers', selectedAnswers);
  
    setSelectedAnswers((prev) => {
        let currentAnswers: number[] = [];

    const raw = prev[questionId];

    // Handle stringified array or directly assigned array
    if (typeof raw === 'string') {
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          currentAnswers = parsed.map((id) => Number(id)).filter((id) => !isNaN(id));
        }
      } catch (e) {
        console.warn('Failed to parse saved answers for question', questionId, e);
      }
    } else if (Array.isArray(raw)) {
      currentAnswers = raw;
    }
      
         // Toggle logic
    const newAnswers = currentAnswers.includes(answerId)
    ? currentAnswers.filter((id) => id !== answerId)
    : [...currentAnswers, answerId];
  
      return {
        ...prev,
        [questionId]: newAnswers,
      };
    });
  };
  

  // Handle save button click
  const handleSave = async () => {
    if (!validateForm()) return;

    const updatedData = {
     questions: Object.entries(selectedAnswers).map(([question_id, answer_id]) => ({
        question_id,
        answer_id,
      })),
    };

    try {
      await updateProfile(userId, updatedData);
      getUserDetails(userId);
  
      toast.success("Information updated successfully!");
      onSaveSuccess();
       setActiveSection(null); // Uncomment to close
    } catch (error) {
      console.log(error);
      
      toast.error("Failed to update Information. Please try again.");
    }
  };
  const personalityQuestion = getQuestionByTitle("Personality");
  const personalityQuestionId = personalityQuestion?.id; // Store it once to avoid multiple calls

 



  return (
    <div className="card border mb-3 filter-container">
      <div className="border-bottom pb-4 mb-4 d-flex w-100 align-items-center gap-3">
        <h4 className="mb-0">Personality Type</h4>
        <button 
          type="button"
          onClick={() => setActiveSection(null)}
          className="btn_close_cross_btn ms-auto"
        >
          <i className="fa-solid fa-xmark"></i>
        </button>
      </div>
      
      <div>
        {personalityQuestion?.questions_options.map((option) => {
          const selectedForQuestion = personalityQuestionId && 
            (Array.isArray(selectedAnswers[personalityQuestionId])
              ? selectedAnswers[personalityQuestionId]
              : []);
          
          const isChecked = selectedForQuestion && 
            (selectedForQuestion.includes(option.id) ||
             user.user_answers.some(
               (answer: any) =>
                 Number(answer.question_id) == personalityQuestionId &&
                 Array.isArray(JSON.parse(answer.answer_id)) &&
                 JSON.parse(answer.answer_id).some((ans: string | number) =>
                   [option.id, option.option].includes(ans)
                 )
             ));
  
          return (
            <div key={option.id} className="d-flex justify-content-between align-items-center mb-2">
              <label htmlFor={`personality-${option.id}`} className="mb-0">
                {option.option}
              </label>
              <input
                type="checkbox"
                id={`personality-${option.id}`}
                name="personality[]"
                checked={isChecked}
                onChange={() => selectOption(option.question_id, option.id)}
                className="form-check-input ms-2"
              />
            </div>
          );
        })}
        {errors.personality && <p className="text-red-500 text-sm">{errors.personality}</p>}
      </div>
  
      <button
        onClick={handleSave}
        className="btn btn-outline-primary w-100 mt-3"
      >
        Save Changes
      </button>
    </div>
  );
};

export default Personality;
